import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsDatepickerViewMode } from "ngx-bootstrap/datepicker/models";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker/bs-datepicker.config";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { TSFuntionService } from "../../services/ts-funtion.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/ngx-bootstrap-typeahead";
import * as _ from "lodash";
import { Router } from "@angular/router";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { SWAlertService } from "../../services/swalert.service";

@Component({
  selector: "app-report-export-universal",
  templateUrl: "./report-export-universal.component.html",
  styleUrls: ["./report-export-universal.component.css"],
})
export class ReportExportUniversalComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private System: TSFuntionService,
    private router: Router,
    private modalService: BsModalService,
    private SW: SWAlertService
  ) {}
  modalRef: BsModalRef;
  arrGL: any;
  bsValue: Date = new Date();
  minMode: BsDatepickerViewMode = "year";
  company: any[] = [];
  paytype: any[] = [];
  IO: any[] = [];
  vandor: any[] = [];
  _vandor: any[] = [];
  Treq: any[] = [];
  _Treq: any[] = [];
  Tuser: any;
  _Tuser: any[] = [];
  DataGL: any[] = [];
  _DataGL: any[] = [];
  sCCTR: any[] = [];
  status: any[] = [];
  settings_com = {};
  settings_pay = {};
  settings_IO = {};
  settings_status = {};
  nStatusID = null;
  txtVendor: string = null;
  CompanyData: any[] = [];
  txtPaymenttype: any[] = [];
  txtPreparer: any;
  txtCCTR: any;
  txtGL: any;
  txtReqNo1: any;
  txtReqNo2: any;
  txtYear: Date = new Date();
  txtIO: any[] = [];
  txtAmount1: any;
  txtAmount2: any;
  txtDueDate: any;
  txtStatus: any[] = [];
  txtReqDate: any[] = [];
  IsVendor: boolean = false;
  IsPreparer: boolean = false;
  IsCCTR: boolean = false;
  IsGL: boolean = false;
  IsReqNo1: boolean = false;
  IsReqNo2: boolean = false;
  sVendor: any;
  nPreparer: any;
  _sCCTR: any;
  sGL: any;
  sReqNo1: any;
  sReqNo2: any;
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 },
    ],
  };
  txtDescription: any;
  _ArrData: any;

  //Set grid
  _ArrDataBind = [];
  sDetailData = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";
  //Head colums
  Columns = [
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Req. No.", SortField: "sRequestCode", Width: "9%" },
    { ColumnName: "Type", SortField: "sReqType", Width: "10%" },
    {
      ColumnName: "Vendor / Customer Name",
      SortField: "sVendorName",
      Width: "19%",
    },
    { ColumnName: "Requester", SortField: "sContactName", Width: "19%" },
    { ColumnName: "Due Date", SortField: "dDueDate", Width: "8%" },
    { ColumnName: "Net Amount", SortField: "nTotalAmount", Width: "13%" },
    { ColumnName: "Cur.", SortField: "sCurrency", Width: "5%" },
    { ColumnName: "Description", SortField: "sDescription", Width: "16%" },
    { ColumnName: "Status", SortField: "sStatusName", Width: "16%" },
  ];
  bsConfig: Partial<BsDatepickerConfig>;
  IsCompanyFilter = false;
  IsLinkStatus = false;
  ngOnInit() {
    this.System.BlockUI();
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.IsCompanyFilter = ua.nRole == 2 || ua.nRole == 6; //SSC OR SVM
      let sCompCode = this.IsCompanyFilter ? "" : ua.sCompCode;
      if (this.IsCompanyFilter) {
        this.CompanyData = [];
        ua.lstCompCode.forEach((f) =>
          this.CompanyData.push({
            COMPANY_CODE: f.sCompCode,
            COMPANY_NAME: f.sCompName,
          })
        );
      }
      this.IsLinkStatus = ua.nRole == 2;
      this.getVendor(sCompCode);
      this.getTUserReq(sCompCode);
      this.getGL(sCompCode);
      this.getTReq(sCompCode);
      this.getIO(sCompCode);
    }
    this.bsConfig = Object.assign(
      {},
      {
        minMode: this.minMode,
      }
    );
    this.getCompany();
    this.getpaytype();
    this.getstatus();
    this.settings_com = {
      singleSelection: false,
      idField: "COMPANY_CODE",
      textField: "COMPANY_NAME",
      enableCheckAll: true,
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: "Search",
      noDataAvailablePlaceholderText: "No Data",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settings_pay = {
      singleSelection: false,
      idField: "nReqType",
      textField: "sReqType",
      enableCheckAll: true,
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: "Search",
      noDataAvailablePlaceholderText: "No Data",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settings_IO = {
      singleSelection: false,
      idField: "ORDER_NUMBER",
      textField: "TXT_IO",
      enableCheckAll: true,
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: "Search",
      noDataAvailablePlaceholderText: "No Data",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settings_status = {
      singleSelection: false,
      idField: "nStatusID",
      textField: "sStatusName",
      enableCheckAll: true,
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: "Search",
      noDataAvailablePlaceholderText: "No Data",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.getsCCTR();

    this.GetData();
    this.System.UnBlockUI();
  }

  getCompany() {
    this.http
      .get<any>(this.System.SiteName + "api/Search/GetCompany")
      .subscribe((res) => {
        if (res) {
          this.company = res;
        }
      });
  }
  getpaytype() {
    this.http.get<any>(this.System.SiteName + "api/Search/Getpaytype").toPromise().then(res => {
      if (res) {
        //I2PI
        this.paytype = res.filter(f => ['10', '11', '12', '20', '30', '40', '50', '60', '61'].includes(f.nReqType));
      }
    });
  }
  getIO(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("COMPANY_CODE", sCompany),
    };
    this.http
      .get<any>(this.System.SiteName + "api/Search/GetIO", httpOptions)
      .subscribe((res) => {
        if (res) {
          this.IO = res;
        }
      });
  }
  getstatus() {
    this.http
      .get<any>(this.System.SiteName + "api/Search/Getstatus")
      .toPromise()
      .then((res) => {
        if (res) {
          this.status = res;
        }
      });
  }
  getVendor(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("COMPANY_CODE", sCompany),
    };
    this.http
      .get<any>(this.System.SiteName + "api/Search/GetVendor", httpOptions)
      .toPromise()
      .then((res) => {
        this.vandor = res;

        this._vandor = res;
      });
  }
  getTReq(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("COMPANY_CODE", sCompany),
    };
    this.http
      .get<any>(this.System.SiteName + "api/Search/GetTReq", httpOptions)
      .toPromise()
      .then((res) => {
        if (res) {
          this._Treq = res;
          this.Treq = res;
        }
      });
  }
  getsCCTR() {
    this.http
      .get<any>(this.System.SiteName + "api/Search/GetsCCTR")
      .toPromise()
      .then((res) => {
        if (res) {
          this.sCCTR = res;
        }
      });
  }
  getTUserReq(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("COMPANY_CODE", sCompany),
    };
    this.http
      .get<any>(this.System.SiteName + "api/Search/GetTUserReq", httpOptions)
      .toPromise()
      .then((res) => {
        if (res) {
          this.Tuser = res;
          this._Tuser = this.Tuser;
        }
      });
  }
  getGL(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("COMPANY_CODE", sCompany),
    };
    this.http
      .get<any>(this.System.SiteName + "api/Search/GetGL", httpOptions)
      .toPromise()
      .then((res) => {
        this.DataGL = res;
        this._DataGL = res;
      });
  }

  onselect_com(item: any) {
    let _data: string[] = [];
    let sCompCode = "";
    for (let i = 0; i < this.CompanyData.length; i++) {
      _data.push(this.CompanyData[i].COMPANY_CODE);
    }
    sCompCode = _data.join(",");
    this.getGL(sCompCode);
    this.getVendor(sCompCode);
    this.getTReq(sCompCode);
    this.getIO(sCompCode);
    this.getTUserReq(sCompCode);
  }
  onselectall_com(item: any) {
    let _data: string[] = [];
    let sCompCode = "";
    for (let i = 0; i < item.length; i++) {
      _data.push(item[i].COMPANY_CODE);
    }
    sCompCode = _data.join(",");
    this.getGL(sCompCode);
    this.getVendor(sCompCode);
    this.getTReq(sCompCode);
    this.getIO(sCompCode);
    this.getTUserReq(sCompCode);
    this.CompanyData = item;
  }
  onDeselect_com(item: any) {
    this.getGL("");
    this.getVendor("");
    this.getTReq("");
    this.getIO("");
    this.getTUserReq("");
    this.CompanyData = item;
  }

  BindDataTable() {
    let user = this.System.GetUserStorage();
    let nRole = user.nRole;
    let status = this.Getstatus(nRole);
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take =
      (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach((val) =>
      this._ArrDataBind.push(Object.assign({}, val))
    );
    this._ArrDataBind = this._ArrDataBind.splice(
      nStartIndex_Take,
      nEndIndex_Take
    );

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData =
      "Showing " +
      nStartItemPage +
      " to " +
      nLastItemPage +
      " of " +
      this._ArrData.length +
      " Rows";
    this.System.UnBlockUI();
  }

  Getstatus(nRole: number) {
    let status = [];
    switch (nRole) {
      case 1:
        status.push(1, 2, 3);
        break;
      case 2:
        status.push(2);
        break;
    }
    return status;
  }

  GetData() {
    this.OptionGrid.nCurrentPage = 1;
    this.System.BlockUI();
    let Result: any;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    let sYear = this.System._IsNullOrEmpty(this.txtYear)
      ? null
      : this.txtYear.getFullYear();

    var reqType = [];
    if (this.txtPaymenttype.length === 0) {
      reqType.push({ nReqType: "10" });
      reqType.push({ nReqType: "11" });
      reqType.push({ nReqType: "12" });
      reqType.push({ nReqType: "20" });
      reqType.push({ nReqType: "30" });
      reqType.push({ nReqType: "40" });
      reqType.push({ nReqType: "50" });
      reqType.push({ nReqType: "60" });
      reqType.push({ nReqType: "61" });
    }
    else {
      reqType = this.txtPaymenttype;
    }

    var data = {
      sVendor:
        this.System._IsNullOrEmpty(this.txtVendor) == true
          ? this.txtVendor
          : this.sVendor,
      sVendorName: this.txtVendor,
      arrCompany: this.CompanyData,
      arrPaymenttype: reqType,
      nPreparer:
        this.System._IsNullOrEmpty(this.txtPreparer) == true
          ? 0
          : this.nPreparer,
      sCCTR: this.txtCCTR,
      sGL: this.txtGL,
      sReqNo1: this.txtReqNo1,
      sReqNo2: this.txtReqNo2,
      nYear: sYear,
      arrIO: this.txtIO,
      nAmount1: this.txtAmount1,
      nAmount2: this.txtAmount2,
      dDueDate: this.txtDueDate,
      arrStatus: this.txtStatus,
      dReqDate: this.txtReqDate,
      sDescription: this.txtDescription,
      IsManual: true,
    };
    let ITEM = JSON.stringify(data);

    this.http
      .post(this.System.SiteName + "api/Search/searchData", ITEM, {
        headers,
        responseType: "json",
      })
      .subscribe((res) => {
        this._ArrData = res == null ? [] : res;
        this.BindDataTable();
      });
  }

  typeaheadNoResults(event, index): void {
    switch (index) {
      case "txtVendor":
        this.IsVendor = event;
        break;
      case "txtPreparer":
        this.IsPreparer = event;
        break;
      case "txtReqNo1":
        this.IsReqNo1 = event;
        break;
      case "txtReqNo2":
        this.IsReqNo2 = event;
        break;
      case "txtCCTR":
        this.IsCCTR = event;
        break;
      case "txtGL":
        this.IsGL = event;
        break;
    }
  }

  typeaheadOnBlur(event: TypeaheadMatch, index) {
    switch (index) {
      case "txtVendor":
        if (this.IsVendor && this.txtVendor) {
          this.sVendor = null;
        } else {
          let sVendor = this.txtVendor.trim();
          let CHK = this._vandor.filter(
            (f) =>
              f.Full_Name == sVendor ||
              f.VENDOR_CODE == sVendor ||
              f.VENDORNAME == sVendor
          );
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtVendor = "";
          }
        }
        break;
      case "txtPreparer":
        if (this.IsPreparer && this.txtPreparer) {
          this.nPreparer = null;
        } else {
          let sPreparer = this.txtPreparer.trim();
          let CHK = this._Tuser.filter((f) => f.Full_Name == sPreparer);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtPreparer = "";
          }
        }

        break;
      case "txtReqNo1":
        if (this.IsReqNo1 && this.txtReqNo1) {
          this.txtReqNo1 = null;
        } else {
          let sReqNo1 = this.txtReqNo1.trim();
          let CHK = this._Treq.filter((f) => f.sRequestCode == sReqNo1);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtReqNo1 = "";
          }
        }
        break;
      case "txtReqNo2":
        if (this.IsReqNo2 && this.txtReqNo2) {
          this.txtReqNo2 = null;
        } else {
          let sReqNo2 = this.txtReqNo2.trim();
          let CHK = this._Treq.filter((f) => f.sRequestCode == sReqNo2);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtReqNo2 = "";
          }
        }
        break;
      case "txtCCTR":
        if (this.IsCCTR && this.txtCCTR) {
          this.txtCCTR = null;
        } else {
          let sCCTR = this.txtCCTR.trim();
          let CHK = this.sCCTR.filter((f) => f.COST_CENTER_NAME == sCCTR);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtCCTR = "";
          }
        }
        break;
      case "txtGL":
        if (this.IsGL && this.txtGL) {
          this.txtGL = null;
        } else {
          let sGL = this.txtGL.trim();
          let CHK = this._DataGL.filter((f) => f.sGLNo == sGL);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtGL = "";
          }
        }
        break;
    }
  }
  onSelect(event: TypeaheadMatch, index) {
    switch (index) {
      case "txtVendor":
        this.sVendor = event.item.VENDOR_CODE;
        break;
      case "txtPreparer":
        this.nPreparer = event.item.nContactID;
        break;
      case "txtReqNo1":
        this.txtReqNo1 = event.value;
        break;
      case "txtReqNo2":
        this.txtReqNo2 = event.value;
        break;
      case "txtCCTR":
        this.txtCCTR = event.value;
        break;
      case "txtGL":
        this.txtGL = event.value;
        break;
    }
  }
  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === "asc" ? "desc" : "asc";
        this.SortICO =
          this.SortDirection === "asc" ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = "asc";
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(
        this._ArrData,
        [SortField],
        [this.SortDirection]
      );
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  //#endregion
  ClearData() {
    this.sVendor = null;
    this.CompanyData = [];
    this.txtPaymenttype = [];
    this.nPreparer = null;
    this.txtPreparer = null;
    this.txtCCTR = null;
    this.txtGL = null;
    this.txtVendor = null;
    this._sCCTR = null;
    this.sGL = null;
    this.sReqNo1 = null;
    this.sReqNo2 = null;
    this.txtReqNo1 = null;
    this.txtReqNo2 = null;
    this.txtYear = new Date();
    this.txtIO = [];
    this.txtAmount1 = null;
    this.txtAmount2 = null;
    this.txtDueDate = null;
    this.txtStatus = [];
    this.txtReqDate = [];
    this._ArrData = [];
    this._ArrDataBind = [];
    this.txtDescription = null;
    if (this.IsCompanyFilter) {
      this.CompanyData = [];
      const ua = this.System.GetUserStorage();
      if (ua) {
        ua.lstCompCode.forEach((f) =>
          this.CompanyData.push({
            COMPANY_CODE: f.sCompCode,
            COMPANY_NAME: f.sCompName,
          })
        );
      }
    }
  }

  async Gotopath(sRequestID) {
    let res = this._ArrData.filter((f) => f.sRequestID == sRequestID);
    let user = this.System.GetUserStorage();
    let nRole = user.nRole;
    let sUrl = "";
    let nStatus = res[0].nStatusID;
    let nReqType = res[0].nReqType;

    //0	Cancel
    //1	Draft
    //2	Waiting Approve1
    //3	Recall
    //4	Waiting Approve2
    //5	Reject By Approve1
    //6	Waiting Receiving Doc
    //7	Reject By Approve2
    //8	Waiting Verify
    //9	Waiting Export to SAP
    //10	Reject By SSC
    //11	Waiting Payment
    //12	Waiting Supporting Document
    //13	Complete
    switch (nRole) {
      case 1: //Admin
        sUrl = "approve";
        break;
      case 2: //SSC
        switch (nStatus) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 10:
            sUrl = "approve";
            break;
          case 8:
          case 9:
          case 11:
          case 12:
          case 13:
          case 15:
            sUrl = "admin-adjust";
            break;
        }
        break;
      case 3: //Approve1
      case 4: //Approve2
        sUrl = "approve";
        break;
      case 5: //Request
      case 7: //ROService
        switch (nStatus) {
          case 0:
            sUrl = "approve";
            break;
          case 1:
          case 3:
          case 5:
          case 7:
          case 10:
            sUrl = this.GetpathTReq(nReqType);
            break;
          case 2:
          case 4:
          case 6:
          case 8:
          case 9:
          case 11:
          case 12:
          case 13:
          case 15:
            sUrl = "approve";
            break;
        }
        break;
      case 6: //SVM
        sUrl = "approve";
        break;
    }
    let ID = await this.System.Encrypt(sRequestID);
    let URL = sUrl + "?str=" + ID;
    window.open(URL, "_blank");

    //if (nRole == 2) {

    //}
    //else {
    //  this.router.navigate([sUrl], { queryParams: { str: ID } });
    //}
  }
  async GotopathStatus(sRequestID) {
    let res = this._ArrData.filter((f) => f.sRequestID == sRequestID);
    let user = this.System.GetUserStorage();
    let nRole = user.nRole;
    let sUrl = "";
    let nStatus = res[0].nStatusID;
    let nReqType = res[0].nReqType;

    //0	Cancel
    //1	Draft
    //2	Waiting Approve1
    //3	Recall
    //4	Waiting Approve2
    //5	Reject By Approve1
    //6	Waiting Receiving Doc
    //7	Reject By Approve2
    //8	Waiting Verify
    //9	Waiting Export to SAP
    //10	Reject By SSC
    //11	Waiting Payment
    //12	Waiting Supporting Document
    //13	Complete

    switch (nRole) {
      case 1: //Admin
        sUrl = "approve";
        break;
      case 2: //SSC
        switch (nStatus) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 7:
          case 10:
          case 13:
          case 15: //Complete
            sUrl = "approve";
            break;
          case 6: //Wait Doc Receiving
            sUrl = "admin-receivingdoc";
            break;
          case 8: //Wait Adjust Invoice
            sUrl = "admin-adjust";
            break;
          case 9: //Wait Export to SAP
            sUrl = "exportto-sap";
            break;
          case 11: //Wait Supporting Document
            sUrl = "admin-payment";
            break;
          case 12: //Complete
            sUrl = "admin-supportdoc";
            break;
        }
        break;
      case 3: //Approve1
      case 4: //Approve2
        sUrl = "approve";
        break;
      case 5: //Request
      case 7: //ROService
        switch (nStatus) {
          case 0:
            sUrl = "approve";
            break;
          case 1:
          case 3:
          case 5:
          case 7:
          case 10:
            sUrl = this.GetpathTReq(nReqType);
            break;
          case 2:
          case 4:
          case 6:
          case 8:
          case 9:
          case 11:
          case 12:
          case 13:
          case 15:
            sUrl = "approve";
            break;
        }
        break;
      case 6: //SVM
        sUrl = "approve";
        break;
    }
    //let ID = await this.System.Encrypt(sRequestID);
    //await this.router.navigate([sUrl], { queryParams: { str: ID } });
    let ID = await this.System.Encrypt(sRequestID);
    let URL = sUrl + "?str=" + ID;
    window.open(URL, "_blank");
  }

  //path at status =1
  GetpathTReq(nReqType: number) {
    let sUrl = "";
    switch (nReqType) {
      case 10:
      case 11:
        sUrl = "paytovendor";
        break;
      case 12:
        sUrl = "paytoemp";
        break;
      case 20:
        sUrl = "advancerequest";
        break;
      case 30:
        sUrl = "clearadvance";
        break;
      case 40:
        sUrl = "pettycash";
        break;
      case 50:
        sUrl = "other";
        break;
      case 60:
      case 61:
        sUrl = "cntype";
        break;
      case 70:
      case 71:
        sUrl = "/billingtocash";
        break;
      case 80:
        sUrl = "/journalvoucher";
        break;
      case 90:
        sUrl = '/receiptvoucher';
        break;
    }
    return sUrl;
  }

  IsSearch: boolean = false;
  SetDvSearch() {
    this.IsSearch = !this.IsSearch;
  }

  ExportExcel() {
    this.System.BlockUI();

    let GetID = this._ArrDataBind.filter((f) => f.IsChecked == true);
    let ID = GetID.map((m) => m.sRequestID).join(",");

    let _this = this;
    let _Data = {
      sMode: "",
      sRequestID: ID,
      IsHeader: true,
      IsColor: true,
    };
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    _this.http
      .post(
        _this.System.SiteName + "api/ExportUniversal/GenerateUniversal",
        JSON.stringify(_Data),
        { headers, responseType: "arraybuffer" }
      )
      .subscribe((res) => {
        this.saveExcel(res, "Universal.xlsx");
      });
  }

  public saveExcel(result, fileName) {
    var blob = new Blob([result], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    if (window.navigator.msSaveOrOpenBlob) {
      // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else {
      // For other browsers:
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
    this.System.UnBlockUI();
  }

  cbExport(item, sRequestID) {
    const DATA = this._ArrDataBind.filter((f) => f.sRequestID === sRequestID);
    if (DATA) {
      DATA[0].IsChecked = item.target.checked;
    }
  }
}
